import React from 'react';
import { AccountBalance } from '@mui/icons-material';
import type { SvgIconProps } from '@mui/material';

export type AgencyIconProps = SvgIconProps;

/** Ícone padrão de agência — reutilizado em monitoramento, filtros e coluna Ações. */
export function AgencyIcon(props: AgencyIconProps) {
  return <AccountBalance {...props} />;
}
